import { unitTypeTransformer } from "./UnitType";
const descriptorMinArea = (descriptor) => {
  const sizeCriteria = descriptor.criteria?.include?.sizes ?? [];
  return Math.min(
    ...descriptor.unitTypes.map((u) => u.dcArea),
    ...sizeCriteria.map((s) => s.width * s.length)
  );
};
const descriptorTransformer = (descriptor, location) => {
  return {
    _id: descriptor._id,
    locationCode: descriptor.sLocationCode,
    corpCode: descriptor.sCorpCode,
    name: descriptor.name,
    description: descriptor.description,
    descriptions: descriptor.descriptions,
    tags: descriptor.tags,
    picture: descriptor.picture,
    slides: descriptor.slides,
    defaultInsuranceCoverage: descriptor.defaultInsuranceCoverage,
    deals: descriptor.deals,
    enabled: descriptor.enabled,
    hidden: descriptor.hidden,
    unitTypes: descriptor.unitTypes.map((u) => unitTypeTransformer(u, location)).filter(
      (item) => location?.rapidstor.hideUnitsMinAvailable ? item.totalAvailable >= location.rapidstor.minAvailableUnits : true
    ),
    ordinalPosition: descriptor.ordinalPosition,
    area: descriptorMinArea(descriptor),
    specialText: descriptor.specialText,
    jblOptionText: descriptor.jblOptionText,
    upgradesTo: descriptor.upgradesTo,
    useForCarousel: descriptor.useForCarousel
  };
};
export {
  descriptorTransformer
};
//# sourceMappingURL=Descriptor.mjs.map